import { Tabs, Tab, Box } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const TAB_CONFIG = [
  { label: "Overview", value: "overview" },
  { label: "Financial Reports", value: "finance-statements" },
  { label: "Financing Rounds", value: "financing-rounds" },
  { label: "Company Updates", value: "company-updates" },
  { label: "Documents", value: "documents" },
];

export default function CompanyTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { companyId } = useParams();
  const currentTab = location.pathname.split("/")[3] || "overview";

/*   const handleChange = (_, newValue) => {
    navigate(`/company/${companyId}/${newValue}`);
  }; */

  const handleChange = (_, newValue) => {
  // Use the optional second argument to pass the current state
  navigate(`/company/${companyId}/${newValue}`, { 
    state: location.state 
  });
};

  return (
    <Box sx={{ borderBottom: "1px solid #e5e7eb", px: 3 }}>
      <Tabs
        value={currentTab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
      >
        {TAB_CONFIG.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            sx={{ textTransform: "none", fontWeight: 500 }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
